var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip ? _vm.$options.filters.date(_vm.datetime) : ''),expression:"tooltip ? $options.filters.date(datetime) : ''"}]},[_vm._v(" "+_vm._s(_vm.date)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }